/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Table_ExpiresInputs */



/**
* | output |
* | --- |
* | "Expires" |
*
* @param {Profile_Security_User_Api_Key_Table_ExpiresInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_table_expires = /** @type {((inputs?: Profile_Security_User_Api_Key_Table_ExpiresInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Table_ExpiresInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Läuft ab")
	return /** @type {LocalizedString} */ ("Expires")
});